// extracted by mini-css-extract-plugin
export default {"user":"mission-table_user__-sjK1"};